

// import { useState, useEffect, useContext, useCallback, useMemo } from "react";
// import MainLayouts from "../../../Layout/MainLayouts";
// import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
// import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
// import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
// import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
// import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
// import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
// import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
// import { ReactComponent as CheckSquare } from "bootstrap-icons/icons/check-square.svg";
// import Spinner from "../../spinner/Spinner";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import ApiServices from "../../../api/ApiServices";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import Swal from "sweetalert2";
// import CustomStyles from "../../../components/utils/CustomStyles";
// import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { handleError } from "../../../components/utils/AuthenticationCheck";
// import AxiosApiCall from "../../../api/AxiosApiCall";
// import { AuthContext } from "../../../AuthProvider/AuthProvider";
// import formatDate from "../../../components/utils/DateFormatter";

// const GetPendingPurchase = () => {
//   const [pendingPurchase, setPendingPurchase] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filterText, setFilterText] = useState("");
//   const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//   const [confirmationLoading, setConfirmationLoading] = useState(false);
//   const { permissions } = useContext(AuthContext);
//   // console.log("admin perm", permissions);
//   const [updatingIncentive, setUpdatingIncentive] = useState(false);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [toggleCleared, setToggleCleared] = useState(false);
//   const [bulkLoading, setBulkLoading] = useState(false);

//   const navigate = useNavigate();
//   const axios = AxiosApiCall();

//   const fetchPendingPurchase = async () => {
//     setLoading(true);
//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) throw new Error("No access token found.");
//       const response = await axios.get(ApiServices.getPendingPurchaseItem, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       });

//       const { status, message, data } = response.data || {};
//       const pendingPurchase = data?.purchases || [];
//       if (status === 200) {
//         setPendingPurchase(pendingPurchase.slice().reverse());
//         toast.success(message, { toastId: "pendingPurchase-fetch-success" });
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPendingPurchase();
//   }, []);

//   // Approve Purchase Function
//   const approvePurchase = async (purchaseId, adminNotes = "") => {
//     try {
//       setUpdatingIncentive(true);
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) throw new Error("No access token found.");

//       const payload = {
//         purchase_id: purchaseId,
//         admin_notes: adminNotes
//       };

//       const response = await axios.post(ApiServices.approvePurchaseItem, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       });

//       const { status, message } = response.data;
//       if (status === 200) {
//         toast.success(message, { toastId: "purchase-approve-success" });
//         await fetchPendingPurchase();
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setUpdatingIncentive(false);
//     }
//   };

//   // Reject Purchase Function
//   const rejectPurchase = async (purchaseId, rejectionReason, adminNotes = "") => {
//     try {
//       setUpdatingIncentive(true);
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) throw new Error("No access token found.");

//       const payload = {
//         purchase_id: purchaseId,
//         rejection_reason: rejectionReason,
//         admin_notes: adminNotes
//       };

//       const response = await axios.post(ApiServices.rejectPurchaseItem, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       });

//       const { status, message } = response.data;
//       if (status === 200) {
//         toast.success(message, { toastId: "purchase-reject-success" });
//         await fetchPendingPurchase();
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setUpdatingIncentive(false);
//     }
//   };

//   // Bulk Approve Purchases Function
//   const bulkApprovePurchases = async (purchaseIds, adminNotes = "") => {
//     try {
//       setBulkLoading(true);
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) throw new Error("No access token found.");

//       const payload = {
//         purchase_ids: purchaseIds,
//         admin_notes: adminNotes
//       };

//       const response = await axios.post(ApiServices.bulkPurchaseApproval, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       });

//       const { status, message } = response.data;
//       if (status === 200) {
//         toast.success(message, { toastId: "bulk-purchase-approve-success" });
//         await fetchPendingPurchase();
//         setSelectedRows([]);
//         setToggleCleared(!toggleCleared);
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setBulkLoading(false);
//     }
//   };

//   const handleApprovalConfirmation = async (purchase) => {
//     const { purchase_id, total_amount, branch_name, purchase_number, name } = purchase;

//     const { value: action } = await Swal.fire({
//       title: "Process Purchase Request",
//       html: `
//         <div class="text-left">
//           <div class="mb-3">
//             <p class="text-sm text-gray-600">Purchase Number: <span class="font-semibold">${purchase_number}</span></p>
//             <p class="text-sm text-gray-600">Branch: <span class="font-semibold">${branch_name}</span></p>
//             <p class="text-sm text-gray-600">Customer: <span class="font-semibold">${name}</span></p>
//           </div>
//           <p class="text-lg font-semibold text-gray-800">Total Amount: <span class="text-darkGreen3">${CurrencyFormatter(total_amount)}</span></p>
//         </div>
//       `,
//       showCancelButton: true,
//       showDenyButton: true,
//       confirmButtonText: "Approve",
//       denyButtonText: "Reject",
//       cancelButtonText: "Cancel",
//       icon: "question",
//       confirmButtonColor: "#3085d6",
//       denyButtonColor: "#d33",
//       cancelButtonColor: "#6c757d"
//     });

//     // Return if user cancels
//     if (action === undefined) return;

//     if (action === true) {
//       // Approval flow
//       const { value: approveValues } = await Swal.fire({
//         title: "Approve Purchase Request",
//         html: `
//           <div class="text-left">
//             <div class="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
//               <p class="text-sm text-gray-700"><span class="font-semibold">Purchase:</span> ${purchase_number}</p>
//               <p class="text-sm text-gray-700"><span class="font-semibold">Branch:</span> ${branch_name}</p>
//               <p class="text-sm text-gray-700"><span class="font-semibold">Total Amount:</span> <span class="text-darkGreen3 font-bold">${CurrencyFormatter(total_amount)}</span></p>
//             </div>
            
//             <label class="block text-gray-700 mb-2">Admin Notes (Optional)</label>
//             <textarea id="admin_notes" placeholder="Add any notes or comments..."
//               class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-darkGreen3 focus:border-transparent"
//               rows="4"></textarea>
//           </div>
//         `,
//         focusConfirm: false,
//         showCancelButton: true,
//         confirmButtonText: "Confirm Approval",
//         confirmButtonColor: "#3085d6",
//         cancelButtonText: "Cancel",
//         preConfirm: () => {
//           const admin_notes = document.getElementById("admin_notes").value;
//           return { admin_notes };
//         },
//       });

//       if (approveValues) {
//         await approvePurchase(purchase_id, approveValues.admin_notes);
//       }
//     } else if (action === false) {
//       // Rejection flow
//       const { value: rejectValues } = await Swal.fire({
//         title: "Reject Purchase Request",
//         html: `
//           <div class="text-left">
//             <div class="mb-4 p-3 bg-red-50 rounded-lg border border-red-200">
//               <p class="text-sm text-gray-700"><span class="font-semibold">Purchase:</span> ${purchase_number}</p>
//               <p class="text-sm text-gray-700"><span class="font-semibold">Branch:</span> ${branch_name}</p>
//               <p class="text-sm text-gray-700"><span class="font-semibold">Total Amount:</span> <span class="text-darkGreen3 font-bold">${CurrencyFormatter(total_amount)}</span></p>
//             </div>
            
//             <label class="block text-gray-700 mb-2 font-semibold">Rejection Reason *</label>
//             <textarea id="rejection_reason" placeholder="Please provide a reason for rejection..."
//               class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent mb-4"
//               rows="3" required></textarea>
            
//             <label class="block text-gray-700 mb-2">Admin Notes (Optional)</label>
//             <textarea id="admin_notes" placeholder="Add any additional notes..."
//               class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
//               rows="3"></textarea>
//           </div>
//         `,
//         focusConfirm: false,
//         showCancelButton: true,
//         confirmButtonText: "Confirm Rejection",
//         confirmButtonColor: "#d33",
//         cancelButtonText: "Cancel",
//         preConfirm: () => {
//           const rejection_reason = document.getElementById("rejection_reason").value;
//           const admin_notes = document.getElementById("admin_notes").value;

//           if (!rejection_reason) {
//             Swal.showValidationMessage("Rejection reason is required");
//             return;
//           }
//           return { rejection_reason, admin_notes };
//         },
//       });

//       if (rejectValues) {
//         await rejectPurchase(purchase_id, rejectValues.rejection_reason, rejectValues.admin_notes);
//       }
//     }
//   };

//   // Handle row selection
//   const handleRowSelected = useCallback((state) => {
//     setSelectedRows(state.selectedRows);
//   }, []);

//   // Handle bulk approval
//   const handleBulkApproval = async () => {
//     if (selectedRows.length === 0) {
//       toast.warning("Please select at least one purchase to approve", { toastId: "no-selection-warning" });
//       return;
//     }

//     const purchaseIds = selectedRows.map(row => row.purchase_id);
//     const totalAmount = selectedRows.reduce((sum, row) => sum + parseFloat(row.total_amount || 0), 0);
//     const branchNames = [...new Set(selectedRows.map(row => row.branch_name))];

//     const { value: approveValues } = await Swal.fire({
//       title: "Bulk Approve Purchases",
//       html: `
//         <div class="text-left">
//           <div class="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
//             <p class="text-sm text-gray-700"><span class="font-semibold">Selected Purchases:</span> ${selectedRows.length}</p>
//             <p class="text-sm text-gray-700"><span class="font-semibold">Branches:</span> ${branchNames.join(", ")}</p>
//             <p class="text-sm text-gray-700"><span class="font-semibold">Total Amount:</span> <span class="text-darkGreen3 font-bold">${CurrencyFormatter(totalAmount)}</span></p>
//             <p class="text-sm text-gray-700 mt-2"><span class="font-semibold">Purchase IDs:</span> ${purchaseIds.join(", ")}</p>
//           </div>
          
//           <label class="block text-gray-700 mb-2">Admin Notes (Optional)</label>
//           <textarea id="admin_notes" placeholder="Add notes for all selected purchases..."
//             class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-darkGreen3 focus:border-transparent"
//             rows="4"></textarea>
//         </div>
//       `,
//       focusConfirm: false,
//       showCancelButton: true,
//       confirmButtonText: bulkLoading ? "Approving..." : `Approve ${selectedRows.length} Purchases`,
//       confirmButtonColor: "#3085d6",
//       cancelButtonText: "Cancel",
//       preConfirm: () => {
//         const admin_notes = document.getElementById("admin_notes").value;
//         return { admin_notes };
//       },
//     });

//     if (approveValues) {
//       await bulkApprovePurchases(purchaseIds, approveValues.admin_notes);
//     }
//   };

//   // Context actions for bulk operations
//   // const contextActions = useMemo(() => {
//   //   return (
//   //     <div className="flex items-center gap-2">
//   //       <button
//   //         onClick={handleBulkApproval}
//   //         disabled={bulkLoading || selectedRows.length === 0}
//   //         className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-darkGreen3 to-green-600 text-white rounded-lg hover:from-darkGreen2 hover:to-green-700 transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed font-semibold text-sm"
//   //       >
//   //         <CheckSquare className="w-4 h-4" />
//   //         {bulkLoading ? "Processing..." : `Approve Selected (${selectedRows.length})`}
//   //       </button>
//   //     </div>
//   //   );
//   // }, [selectedRows, bulkLoading]);

  
//     // Context actions for bulk operations
//     const contextActions = useMemo(() => {
//       if (!permissions.some(p => p.name === "branch.purchase.approve")) return null;
  
//       return (
//         <div className="flex justify-end mb-4">
//           <button
//             onClick={handleBulkApproval}
//             disabled={bulkLoading || selectedRows.length === 0}
//             className="flex items-center gap-2 px-4 py-2 bg-darkGreen3 text-white rounded-lg hover:bg-green-700 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             <CheckSquare className="w-4 h-4" />
//             {bulkLoading
//               ? "Processing..."
//               : `Approve Selected (${selectedRows.length})`}
//           </button>
//         </div>
//       );
//     }, [permissions, selectedRows.length, bulkLoading]);

//   const ExpandableComponent = ({ data, handleApprovalConfirmation }) => {
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 5;

//     // Ensure items is always an array
//     const items = Array.isArray(data?.items) ? data.items : [];
//     const totalItems = items.length;
//     const totalPages = Math.ceil(totalItems / itemsPerPage);

//     // Slice items for current page
//     const paginatedItems = items.slice(
//       (currentPage - 1) * itemsPerPage,
//       currentPage * itemsPerPage
//     );

//     // Pagination navigation handlers
//     const handleNext = () => {
//       if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
//     };

//     const handlePrev = () => {
//       if (currentPage > 1) setCurrentPage((prev) => prev - 1);
//     };

//     // Reset to page 1 when data changes
//     useEffect(() => {
//       setCurrentPage(1);
//     }, [data]);

//     return (
//       <div className="p-4 bg-gray-50 rounded-lg border border-lGrey shadow-sm space-y-4">
//         {items.length > 0 ? (
//           <div className="p-4 bg-gray-100 rounded-md">
//             <h4 className="font-bold mb-2 text-gray-800">
//               Items in this Purchase:
//             </h4>

//             <div className="overflow-x-auto">
//               <table className="w-full text-sm text-left">
//                 <thead className="bg-darkGreen3 text-lGrey uppercase">
//                   <tr>
//                     <th className="px-4 py-2">No</th>
//                     <th className="px-4 py-2">Product Name</th>
//                     <th className="px-4 py-2">Category</th>
//                     <th className="px-4 py-2">Quantity</th>
//                     <th className="px-4 py-2">Unit Price</th>
//                     <th className="px-4 py-2">Total</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paginatedItems.map((item, index) => (
//                     <tr key={item.item_id} className="border-b hover:bg-gray-50">
//                       <td className="px-4 py-2 font-medium">
//                         {(currentPage - 1) * itemsPerPage + index + 1}
//                       </td>
//                       <td className="px-4 py-2">{item.product_name}</td>
//                       <td className="px-4 py-2">{item.product_category}</td>
//                       <td className="px-4 py-2">{item.quantity}</td>
//                       <td className="px-4 py-2">
//                         ₦{CurrencyFormatter(item.unit_price)}
//                       </td>
//                       <td className="px-4 py-2">
//                         ₦{CurrencyFormatter(item.total_amount)}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination controls */}
//             {totalPages > 1 && (
//               <div className="flex justify-start items-center mt-3 space-x-2">
//                 <button
//                   onClick={handlePrev}
//                   disabled={currentPage === 1}
//                   className="bg-black2 text-lGrey px-4 py-2 rounded hover:bg-orange1 disabled:opacity-50"
//                 >
//                   Prev
//                 </button>

//                 <button
//                   onClick={handleNext}
//                   disabled={currentPage === totalPages}
//                   className="bg-black2 text-lGrey px-4 py-2 rounded hover:bg-orange1 disabled:opacity-50"
//                 >
//                   Next
//                 </button>
//               </div>
//             )}
//           </div>
//         ) : (
//           <div className="p-4 bg-yellow-100 rounded-md">
//             <p className="text-yellow-800">No items found for this purchase.</p>
//           </div>
//         )}

//         {/* Action Buttons  
//         // */}
//         {permissions.some(permission => permission.name === 'branch.purchase.approve') && (
//           <div className="flex items-center justify-start gap-3 mt-2">
//             <div className="mx-2 my-2 group relative">
//               <button
//                 onClick={() => handleApprovalConfirmation(data)}
//                 className="p-2 rounded hover:bg-gray-200 transition disabled:opacity-50"
//               >
//                 <PlusSquareFill className="w-5 h-5 text-darkGreen3" />
//               </button>
//               <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-darkGreen3 text-xs px-2 py-1 rounded whitespace-nowrap z-10">
//                 Approve/Reject
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   const handleFilter = (e) => {
//     setFilterText(e.target.value);
//     setResetPaginationToggle(!resetPaginationToggle);
//   };

//   const columns = [
//     {
//       name: "Purchase Number",
//       selector: (row) => row.purchase_number || "NOT AVAILABLE",
//       sortable: true,
//       width: "220px",
//     },
//     {
//       name: "Branch",
//       selector: (row) => row.branch_name || "NOT AVAILABLE",
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Customer Name",
//       selector: (row) => row.name ? row.name.toUpperCase() : "NOT AVAILABLE",
//       sortable: true,
//       width: "180px",
//     },
//     {
//       name: "Total Amount",
//       selector: (row) => CurrencyFormatter(row.total_amount) || "0.00",
//       sortable: true,
//       width: "160px",
//     },
//     {
//       name: "Phone",
//       selector: (row) => row.phone || "NOT AVAILABLE",
//       sortable: true,
//       width: "180px",
//     },
//     {
//       name: "Email",
//       selector: (row) => row.email || "NOT AVAILABLE",
//       sortable: true,
//       width: "240px",
//     },
//     {
//       name: "Payment Status",
//       cell: (row) => (
//         <span
//           className={`${row.payment_status === "unpaid"
//             ? "text-orange1"
//             : "text-darkGreen3"
//             } font-semibold`}
//         >
//           {row.payment_status || "NOT AVAILABLE"}
//         </span>
//       ),
//       sortable: true,
//       width: "140px",
//     },
//     {
//       name: "Delivery Status",
//       cell: (row) => (
//         <span
//           className={`${row.delivery_status === "pending"
//             ? "text-orange1"
//             : "text-darkGreen3"
//             } font-semibold`}
//         >
//           {row.delivery_status}
//         </span>
//       ),
//       sortable: true,
//       width: "140px",
//     },
//     {
//       name: "Approval Status",
//       cell: (row) => (
//         <span
//           className={`${row.approval_status === "pending"
//             ? "text-orange1"
//             : row.approval_status === "approved"
//               ? "text-darkGreen3"
//               : "text-red-500"
//             } font-semibold`}
//         >
//           {row.approval_status}
//         </span>
//       ),
//       sortable: true,
//       width: "140px",
//     },
//     {
//       name: "Purchase Date",
//       selector: (row) =>
//         row.purchase_date ? formatDate(row.purchase_date) : "NOT AVAILABLE",
//       sortable: true,
//       width: "180px",
//     },
//   ];

//   const filteredItems = pendingPurchase.filter((item) =>
//     Object.values(item || {})
//       .join(" ")
//       .toLowerCase()
//       .includes(filterText.toLowerCase())
//   );

//   return (
//     <MainLayouts>
//       <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//         <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
//           <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//             <ol className="list-none p-0 inline-flex mb-2">
//               <li className="flex items-center">
//                 <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">Operations</p>
//                 <ChevronRightIcon />
//               </li>
//               <li className="flex items-center">
//                 <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">Purchase Stock</p>
//                 <ChevronRightIcon />
//               </li>
//               <li className="flex items-center">
//                 <p className="text-orange1">Pending</p>
//               </li>
//             </ol>
//           </nav>
//         </section>

//         {/* Bulk Actions Info */}
//         {selectedRows.length > 0 && (
//           <div className="sticky top-0 z-10 bg-darkGreen3-50 border border-darkGreen3 rounded-lg mb-3 p-3 flex items-center justify-between shadow-sm">
//             <div>
//               <p className="text-darkGreen3 font-semibold">{selectedRows.length} selected</p>
//               <p className="text-sm text-darkGreen3">
//                 Total Amount: {CurrencyFormatter(selectedRows.reduce((sum, row) => sum + parseFloat(row.total_amount || 0), 0))}
//               </p>
//             </div>
//             <button
//               onClick={handleBulkApproval}
//               disabled={bulkLoading}
//               className="bg-darkGreen3 text-lGrey px-4 py-2 rounded-lg hover:bg-darkGreen3-700 transition-all disabled:opacity-50"
//             >
//               {bulkLoading ? "Processing..." : `Approve Selected (${selectedRows.length})`}
//             </button>
//           </div>
//         )}

//         <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
//           <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
//             <input
//               type="search"
//               className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-darkGreen3 focus:border-transparent"
//               placeholder="Search by purchase number, branch, customer..."
//               value={filterText}
//               onChange={handleFilter}
//             />
//           </div>
//         </div>
//         {loading ? (
//           <Spinner />
//         ) : (
//           <DataTable
//             columns={columns}
//             data={filteredItems}
//             pagination
//             highlightOnHover
//             striped
//             customStyles={CustomStyles}
//             noDataComponent={<div className="py-8 text-center text-gray-500">No pending purchase stock found</div>}
//             expandableRows
//             expandableRowsComponent={(props) => (
//               <ExpandableComponent
//                 data={props.data}
//                 handleApprovalConfirmation={handleApprovalConfirmation}
//               />
//             )}
//             selectableRows
//             onSelectedRowsChange={handleRowSelected}
//             contextActions={contextActions}
//             clearSelectedRows={toggleCleared}
//             selectableRowsHighlight
//             selectableRowsVisibleOnly={false}
//             persistTableHead   // ✅ add this line
//           />
//         )}
//       </div>
//     </MainLayouts>
//   );
// };

// export default GetPendingPurchase;




import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import { ReactComponent as CheckSquare } from "bootstrap-icons/icons/check-square.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
import formatDate from "../../../components/utils/DateFormatter";
import { downloadCSVFromApi } from "../../../components/utils/DownlaodCSVFromApi";

const GetPendingPurchase = () => {
  const [pendingPurchase, setPendingPurchase] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const { permissions } = useContext(AuthContext);
  const [updatingIncentive, setUpdatingIncentive] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);

  // Date filters for CSV download and table filtering
  const [dateFilters, setDateFilters] = useState({
    start_date: "",
    end_date: "",
  });

  const navigate = useNavigate();
  const axios = AxiosApiCall();

  const fetchPendingPurchase = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");
      const response = await axios.get(ApiServices.getPendingPurchaseItem, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message, data } = response.data || {};
      const pendingPurchase = data?.purchases || [];
      if (status === 200) {
        setPendingPurchase(pendingPurchase.slice().reverse());
        toast.success(message, { toastId: "pendingPurchase-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingPurchase();
  }, []);

  // Handle date filter changes for CSV
  const handleDateFilterChange = (key, value) => {
    setDateFilters((prev) => ({ ...prev, [key]: value }));
  };

  // Check if both dates are selected for CSV download and table filtering
  const areDatesSelected = dateFilters.start_date && dateFilters.end_date;

  // Handle CSV Download - Server-side filtered by date
  const handleDownloadCSV = async () => {
    if (!areDatesSelected) {
      toast.error("Please select both start and end dates to download CSV");
      return;
    }

    // Validate date range
    const startDate = new Date(dateFilters.start_date);
    const endDate = new Date(dateFilters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    // Limit date range to a year
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (daysDiff > 365) {
      toast.error("Date range cannot exceed 1 year");
      return;
    }

    setLoadingCSV(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;

      if (!token) {
        toast.error("No access token found");
        return;
      }

      // Prepare download payload for pending purchases
      const downloadPayload = {
        start_date: dateFilters.start_date,
        end_date: dateFilters.end_date,
        download: 1,
      };

      // Create filename with date range
      const startDateFormatted = dateFilters.start_date.replace(/-/g, '_');
      const endDateFormatted = dateFilters.end_date.replace(/-/g, '_');
      const filename = `pending_purchases_${startDateFormatted}_to_${endDateFormatted}.csv`;

      // Call the download function - use the same API endpoint as pending purchases
      await downloadCSVFromApi(
        ApiServices.getPendingPurchaseItem,
        downloadPayload,
        token,
        {
          filename: filename,
          columnsToRemove: [], // Add sensitive columns to exclude 
          maxRows: 50000
        }
      );

    } catch (error) {
      console.error("Download error:", error);
      handleError(error, navigate);
      // Additional download-specific error messages
      if (error.message && error.message.includes("CSV")) {
        toast.error("Failed to process CSV file");
      } else if (error.message && error.message.includes("network")) {
        toast.error("Network error during download");
      }
    } finally {
      setLoadingCSV(false);
    }
  };

  // Clear date filters
  const handleClearDates = () => {
    setDateFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("Date filters cleared");
  };

  // Handle filter for search text
  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Filter data based on search text AND date range
  const filteredItems = pendingPurchase.filter((item) => {
    // Filter by search text
    const matchesFilterText = Object.values(item).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(filterText.toLowerCase())
    );

    // Filter data based on date range
    let matchesDateRange = true;
    if (areDatesSelected) {
      const itemDate = new Date(item.purchase_date || item.created_at);
      const startDate = new Date(dateFilters.start_date);
      const endDate = new Date(dateFilters.end_date);

      // Set time to end of day for end date
      // 23: Hours(24 - hour format) = 11:00 PM
      // 59: Minutes = 59 minutes past the hour
      // 59: Seconds = 59 seconds past the minute
      // 999: Milliseconds = 999 milliseconds past the second
      endDate.setHours(23, 59, 59, 999);

      matchesDateRange = itemDate >= startDate && itemDate <= endDate;
    }

    return matchesFilterText && matchesDateRange;
  });

  // Rest of your existing functions remain the same...
  // Approve Purchase Function
  const approvePurchase = async (purchaseId, adminNotes = "") => {
    try {
      setUpdatingIncentive(true);
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const payload = {
        purchase_id: purchaseId,
        admin_notes: adminNotes
      };

      const response = await axios.post(ApiServices.approvePurchaseItem, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "purchase-approve-success" });
        await fetchPendingPurchase();
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setUpdatingIncentive(false);
    }
  };

  // Reject Purchase Function
  const rejectPurchase = async (purchaseId, rejectionReason, adminNotes = "") => {
    try {
      setUpdatingIncentive(true);
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const payload = {
        purchase_id: purchaseId,
        rejection_reason: rejectionReason,
        admin_notes: adminNotes
      };

      const response = await axios.post(ApiServices.rejectPurchaseItem, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "purchase-reject-success" });
        await fetchPendingPurchase();
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setUpdatingIncentive(false);
    }
  };

  // Bulk Approve Purchases Function
  const bulkApprovePurchases = async (purchaseIds, adminNotes = "") => {
    try {
      setBulkLoading(true);
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const payload = {
        purchase_ids: purchaseIds,
        admin_notes: adminNotes
      };

      const response = await axios.post(ApiServices.bulkPurchaseApproval, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "bulk-purchase-approve-success" });
        await fetchPendingPurchase();
        setSelectedRows([]);
        setToggleCleared(!toggleCleared);
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setBulkLoading(false);
    }
  };

  const handleApprovalConfirmation = async (purchase) => {
    const { purchase_id, total_amount, branch_name, purchase_number, name } = purchase;

    const { value: action } = await Swal.fire({
      title: "Process Purchase Request",
      html: `
        <div class="text-left">
          <div class="mb-3">
            <p class="text-sm text-gray-600">Purchase Number: <span class="font-semibold">${purchase_number}</span></p>
            <p class="text-sm text-gray-600">Branch: <span class="font-semibold">${branch_name}</span></p>
            <p class="text-sm text-gray-600">Customer: <span class="font-semibold">${name}</span></p>
          </div>
          <p class="text-lg font-semibold text-gray-800">Total Amount: <span class="text-darkGreen3">${CurrencyFormatter(total_amount)}</span></p>
        </div>
      `,
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "Approve",
      denyButtonText: "Reject",
      cancelButtonText: "Cancel",
      icon: "question",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#d33",
      cancelButtonColor: "#6c757d"
    });

    // Return if user cancels
    if (action === undefined) return;

    if (action === true) {
      // Approval flow
      const { value: approveValues } = await Swal.fire({
        title: "Approve Purchase Request",
        html: `
          <div class="text-left">
            <div class="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
              <p class="text-sm text-gray-700"><span class="font-semibold">Purchase:</span> ${purchase_number}</p>
              <p class="text-sm text-gray-700"><span class="font-semibold">Branch:</span> ${branch_name}</p>
              <p class="text-sm text-gray-700"><span class="font-semibold">Total Amount:</span> <span class="text-darkGreen3 font-bold">${CurrencyFormatter(total_amount)}</span></p>
            </div>
            
            <label class="block text-gray-700 mb-2">Admin Notes (Optional)</label>
            <textarea id="admin_notes" placeholder="Add any notes or comments..."
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-darkGreen3 focus:border-transparent"
              rows="4"></textarea>
          </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Confirm Approval",
        confirmButtonColor: "#3085d6",
        cancelButtonText: "Cancel",
        preConfirm: () => {
          const admin_notes = document.getElementById("admin_notes").value;
          return { admin_notes };
        },
      });

      if (approveValues) {
        await approvePurchase(purchase_id, approveValues.admin_notes);
      }
    } else if (action === false) {
      // Rejection flow
      const { value: rejectValues } = await Swal.fire({
        title: "Reject Purchase Request",
        html: `
          <div class="text-left">
            <div class="mb-4 p-3 bg-red-50 rounded-lg border border-red-200">
              <p class="text-sm text-gray-700"><span class="font-semibold">Purchase:</span> ${purchase_number}</p>
              <p class="text-sm text-gray-700"><span class="font-semibold">Branch:</span> ${branch_name}</p>
              <p class="text-sm text-gray-700"><span class="font-semibold">Total Amount:</span> <span class="text-darkGreen3 font-bold">${CurrencyFormatter(total_amount)}</span></p>
            </div>
            
            <label class="block text-gray-700 mb-2 font-semibold">Rejection Reason *</label>
            <textarea id="rejection_reason" placeholder="Please provide a reason for rejection..."
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent mb-4"
              rows="3" required></textarea>
            
            <label class="block text-gray-700 mb-2">Admin Notes (Optional)</label>
            <textarea id="admin_notes" placeholder="Add any additional notes..."
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows="3"></textarea>
          </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Confirm Rejection",
        confirmButtonColor: "#d33",
        cancelButtonText: "Cancel",
        preConfirm: () => {
          const rejection_reason = document.getElementById("rejection_reason").value;
          const admin_notes = document.getElementById("admin_notes").value;

          if (!rejection_reason) {
            Swal.showValidationMessage("Rejection reason is required");
            return;
          }
          return { rejection_reason, admin_notes };
        },
      });

      if (rejectValues) {
        await rejectPurchase(purchase_id, rejectValues.rejection_reason, rejectValues.admin_notes);
      }
    }
  };

  // Handle row selection
  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  // Handle bulk approval
  const handleBulkApproval = async () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one purchase to approve", { toastId: "no-selection-warning" });
      return;
    }

    const purchaseIds = selectedRows.map(row => row.purchase_id);
    const totalAmount = selectedRows.reduce((sum, row) => sum + parseFloat(row.total_amount || 0), 0);
    const branchNames = [...new Set(selectedRows.map(row => row.branch_name))];

    const { value: approveValues } = await Swal.fire({
      title: "Bulk Approve Purchases",
      html: `
        <div class="text-left">
          <div class="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
            <p class="text-sm text-gray-700"><span class="font-semibold">Selected Purchases:</span> ${selectedRows.length}</p>
            <p class="text-sm text-gray-700"><span class="font-semibold">Branches:</span> ${branchNames.join(", ")}</p>
            <p class="text-sm text-gray-700"><span class="font-semibold">Total Amount:</span> <span class="text-darkGreen3 font-bold">${CurrencyFormatter(totalAmount)}</span></p>
            <p class="text-sm text-gray-700 mt-2"><span class="font-semibold">Purchase IDs:</span> ${purchaseIds.join(", ")}</p>
          </div>
          
          <label class="block text-gray-700 mb-2">Admin Notes (Optional)</label>
          <textarea id="admin_notes" placeholder="Add notes for all selected purchases..."
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-darkGreen3 focus:border-transparent"
            rows="4"></textarea>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: bulkLoading ? "Approving..." : `Approve ${selectedRows.length} Purchases`,
      confirmButtonColor: "#3085d6",
      cancelButtonText: "Cancel",
      preConfirm: () => {
        const admin_notes = document.getElementById("admin_notes").value;
        return { admin_notes };
      },
    });

    if (approveValues) {
      await bulkApprovePurchases(purchaseIds, approveValues.admin_notes);
    }
  };

  // Context actions for bulk operations
  const contextActions = useMemo(() => {
    if (!permissions.some(p => p.name === "branch.purchase.approve")) return null;

    return (
      <div className="flex justify-end mb-4">
        <button
          onClick={handleBulkApproval}
          disabled={bulkLoading || selectedRows.length === 0}
          className="flex items-center gap-2 px-4 py-2 bg-darkGreen3 text-white rounded-lg hover:bg-green-700 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <CheckSquare className="w-4 h-4" />
          {bulkLoading
            ? "Processing..."
            : `Approve Selected (${selectedRows.length})`}
        </button>
      </div>
    );
  }, [permissions, selectedRows.length, bulkLoading]);

  // Rest of your component remains the same...
  const ExpandableComponent = ({ data, handleApprovalConfirmation }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    // Ensure items is always an array
    const items = Array.isArray(data?.items) ? data.items : [];
    const totalItems = items.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Slice items for current page
    const paginatedItems = items.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

    // Pagination navigation handlers
    const handleNext = () => {
      if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const handlePrev = () => {
      if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    // Reset to page 1 when data changes
    useEffect(() => {
      setCurrentPage(1);
    }, [data]);

    return (
      <div className="p-4 bg-gray-50 rounded-lg border border-lGrey shadow-sm space-y-4">
        {items.length > 0 ? (
          <div className="p-4 bg-gray-100 rounded-md">
            <h4 className="font-bold mb-2 text-gray-800">
              Items in this Purchase:
            </h4>

            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left">
                <thead className="bg-darkGreen3 text-lGrey uppercase">
                  <tr>
                    <th className="px-4 py-2">No</th>
                    <th className="px-4 py-2">Product Name</th>
                    <th className="px-4 py-2">Category</th>
                    <th className="px-4 py-2">Quantity</th>
                    <th className="px-4 py-2">Unit Price</th>
                    <th className="px-4 py-2">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedItems.map((item, index) => (
                    <tr key={item.item_id} className="border-b hover:bg-gray-50">
                      <td className="px-4 py-2 font-medium">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td className="px-4 py-2">{item.product_name}</td>
                      <td className="px-4 py-2">{item.product_category}</td>
                      <td className="px-4 py-2">{item.quantity}</td>
                      <td className="px-4 py-2">
                        ₦{CurrencyFormatter(item.unit_price)}
                      </td>
                      <td className="px-4 py-2">
                        ₦{CurrencyFormatter(item.total_amount)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination controls */}
            {totalPages > 1 && (
              <div className="flex justify-start items-center mt-3 space-x-2">
                <button
                  onClick={handlePrev}
                  disabled={currentPage === 1}
                  className="bg-black2 text-lGrey px-4 py-2 rounded hover:bg-orange1 disabled:opacity-50"
                >
                  Prev
                </button>

                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                  className="bg-black2 text-lGrey px-4 py-2 rounded hover:bg-orange1 disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className="p-4 bg-yellow-100 rounded-md">
            <p className="text-yellow-800">No items found for this purchase.</p>
          </div>
        )}

        {/* Action Buttons */}
        {permissions.some(permission => permission.name === 'branch.purchase.approve') && (
          <div className="flex items-center justify-start gap-3 mt-2">
            <div className="mx-2 my-2 group relative">
              <button
                onClick={() => handleApprovalConfirmation(data)}
                className="p-2 rounded hover:bg-gray-200 transition disabled:opacity-50"
              >
                <PlusSquareFill className="w-5 h-5 text-darkGreen3" />
              </button>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-darkGreen3 text-xs px-2 py-1 rounded whitespace-nowrap z-10">
                Approve/Reject
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const columns = [
    {
      name: "Purchase Number",
      selector: (row) => row.purchase_number || "NOT AVAILABLE",
      sortable: true,
      width: "220px",
    },
    {
      name: "Branch",
      selector: (row) => row.branch_name || "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Customer Name",
      selector: (row) => row.name ? row.name.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      width: "180px",
    },
    {
      name: "Total Amount",
      selector: (row) => CurrencyFormatter(row.total_amount) || "0.00",
      sortable: true,
      width: "160px",
    },
    {
      name: "Phone",
      selector: (row) => row.phone || "NOT AVAILABLE",
      sortable: true,
      width: "180px",
    },
    {
      name: "Email",
      selector: (row) => row.email || "NOT AVAILABLE",
      sortable: true,
      width: "240px",
    },
    {
      name: "Payment Status",
      cell: (row) => (
        <span
          className={`${row.payment_status === "unpaid"
            ? "text-orange1"
            : "text-darkGreen3"
            } font-semibold`}
        >
          {row.payment_status || "NOT AVAILABLE"}
        </span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Delivery Status",
      cell: (row) => (
        <span
          className={`${row.delivery_status === "pending"
            ? "text-orange1"
            : "text-darkGreen3"
            } font-semibold`}
        >
          {row.delivery_status}
        </span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Approval Status",
      cell: (row) => (
        <span
          className={`${row.approval_status === "pending"
            ? "text-orange1"
            : row.approval_status === "approved"
              ? "text-darkGreen3"
              : "text-red-500"
            } font-semibold`}
        >
          {row.approval_status}
        </span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Purchase Date",
      selector: (row) =>
        row.purchase_date ? formatDate(row.purchase_date) : "NOT AVAILABLE",
      sortable: true,
      width: "180px",
    },
  ];

  return (
    <MainLayouts>
      <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
        <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
          <nav className="bg-gray-200 py-0 px-4 rounded-lg">
            <ol className="list-none p-0 inline-flex mb-2">
              <li className="flex items-center">
                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">Operations</p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">Purchase Stock</p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-orange1">Pending</p>
              </li>
            </ol>
          </nav>
        </section>

        {/* Bulk Actions Info */}
        {selectedRows.length > 0 && (
          <div className="sticky top-0 z-10 bg-darkGreen3-50 border border-darkGreen3 rounded-lg mb-3 p-3 flex items-center justify-between shadow-sm">
            <div>
              <p className="text-darkGreen3 font-semibold">{selectedRows.length} selected</p>
              <p className="text-sm text-darkGreen3">
                Total Amount: {CurrencyFormatter(selectedRows.reduce((sum, row) => sum + parseFloat(row.total_amount || 0), 0))}
              </p>
            </div>
            <button
              onClick={handleBulkApproval}
              disabled={bulkLoading}
              className="bg-darkGreen3 text-lGrey px-4 py-2 rounded-lg hover:bg-darkGreen3-700 transition-all disabled:opacity-50"
            >
              {bulkLoading ? "Processing..." : `Approve Selected (${selectedRows.length})`}
            </button>
          </div>
        )}

        {/* Search, Date Filters and Download in One Row */}
        <div className="pb-4 bg-white dark:bg-gray-900">
          <div className="flex flex-wrap gap-3 mb-4">
            {/* Search Input with Icon */}
            <div className="relative flex-grow min-w-[250px]">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                  type="search"
                  className="block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-darkGreen3 focus:border-transparent"
                  placeholder="Search by purchase number, branch, customer..."
                  value={filterText}
                  onChange={handleFilter}
                />
              </div>
            </div>

            {/* Start Date Input */}
            <div className="min-w-[150px]">
              <input
                type="date"
                value={dateFilters.start_date}
                onChange={(e) => handleDateFilterChange("start_date", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                max={dateFilters.end_date || undefined}
                placeholder="Start Date"
              />
            </div>

            {/* End Date Input */}
            <div className="min-w-[150px]">
              <input
                type="date"
                value={dateFilters.end_date}
                onChange={(e) => handleDateFilterChange("end_date", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                min={dateFilters.start_date || undefined}
                placeholder="End Date"
              />
            </div>

            {/* Clear Dates Button - Only show when dates are selected */}
            {areDatesSelected && (
              <button
                onClick={handleClearDates}
                className="inline-flex justify-center items-center gap-x-2 px-4 py-2 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-700 transition-colors duration-200 whitespace-nowrap"
              >
                Clear Dates
              </button>
            )}

            {/* Download CSV Button */}
            <button
              onClick={handleDownloadCSV}
              className={`inline-flex justify-center items-center gap-x-2 px-4 py-2 rounded-md text-sm font-semibold transition-colors duration-200 whitespace-nowrap ${areDatesSelected
                ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
              disabled={!areDatesSelected || loadingCSV}
              title={!areDatesSelected ? "Select start and end dates to enable download" : "Download CSV for selected date range"}
            >
              {loadingCSV ? (
                <>
                  <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                  <span className="ml-1">Downloading...</span>
                </>
              ) : (
                <>
                  <Download className="w-4 h-4" />
                  <span className="ml-1">Download CSV</span>
                </>
              )}
            </button>
          </div>

          {/* Help text showing filtered results */}
          {areDatesSelected && filteredItems.length > 0 && (
            <div className="mt-2">
              <p className="text-sm text-gray-600">
                Showing {filteredItems.length} pending purchases from {dateFilters.start_date} to {dateFilters.end_date}
              </p>
              
            </div>
          )}
          {areDatesSelected && filteredItems.length === 0 && (
            <div className="mt-2">
              <p className="text-sm text-orange1">
                No pending purchases found for the selected date range ({dateFilters.start_date} to {dateFilters.end_date})
              </p>
            </div>
          )}
          {!areDatesSelected && (
            <div className="mt-2">
              <p className="text-xs text-gray-500">
                Select start and end dates to filter records and enable CSV download
              </p>
            </div>
          )}
        </div>

        {loading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={filteredItems}
            pagination
            highlightOnHover
            striped
            customStyles={CustomStyles}
            noDataComponent={
              <div className="py-8 text-center text-gray-500">
                {areDatesSelected
                  ? `No pending purchases found for ${dateFilters.start_date} to ${dateFilters.end_date}`
                  : "No pending purchase stock found"
                }
              </div>
            }
            expandableRows
            expandableRowsComponent={(props) => (
              <ExpandableComponent
                data={props.data}
                handleApprovalConfirmation={handleApprovalConfirmation}
              />
            )}
            selectableRows
            onSelectedRowsChange={handleRowSelected}
            contextActions={contextActions}
            clearSelectedRows={toggleCleared}
            selectableRowsHighlight
            selectableRowsVisibleOnly={false}
            persistTableHead
          />
        )}
      </div>
    </MainLayouts>
  );
};

export default GetPendingPurchase;




